import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { RichtextCarousel as RichtextCarouselCL } from '@comicrelief/component-library';
import { snakeCase } from 'lodash';
import renderBody from '../RichText/RichText';
import formatNodes from './_utils';
import { paddingOptionMapping } from '../../utils/optionMapping';

const RichtextCarousel = ({
  data: {
    headingCopy, nodes, mobileHeight, tabletHeight, desktopHeight,
    paddingAbove, paddingBelow, autoPlay, rowBackgroundColour,
    carouselBackgroundColour, nodeBackgroundColour,
    nodeOutlineColour, contentful_id: thisID
  }
}) => {
  // Prepare the data for the component:

  const thisRowBgColour = rowBackgroundColour ? snakeCase(rowBackgroundColour) : null;
  const thisCarouselBg = carouselBackgroundColour ? snakeCase(carouselBackgroundColour) : null;
  const thiseNodeBgColour = nodeBackgroundColour ? snakeCase(nodeBackgroundColour) : null;
  const [formattedDataReady, setFormattedDataReady] = useState(null);
  // Map the human-readable labels to the actual values:
  const paddingTop = paddingAbove ? paddingOptionMapping[paddingAbove] : undefined;
  const paddingBottom = paddingBelow ? paddingOptionMapping[paddingBelow] : undefined;
  let formattedNodes;
  let thisHeadingCopy;

  useEffect(() => {
    // Preprocess our content on mount:
    formattedNodes = formatNodes(nodes, thiseNodeBgColour);
    thisHeadingCopy = renderBody(headingCopy, thisCarouselBg);

    const formattedData = {
      autoPlay,
      carouselBackgroundColour: thisCarouselBg,
      contentful_id: thisID,
      headingCopy: thisHeadingCopy,
      nodeBackgroundColour: thiseNodeBgColour,
      nodeOutlineColour: rowBackgroundColour ? snakeCase(nodeOutlineColour) : null,
      rowBackgroundColour: thisRowBgColour,
      paddingTop,
      paddingBottom,
      // Only pass these optional fields when set:
      ...(mobileHeight && { mobileHeight }),
      ...(tabletHeight && { tabletHeight }),
      ...(desktopHeight && { desktopHeight }),
      // Our actual content:
      nodes: formattedNodes
    };

    // Store our formatted data to the state also acting as a render flag:
    setFormattedDataReady(formattedData);
  }, []);

  return (
    formattedDataReady && (
      <RichtextCarouselCL data={formattedDataReady} />
    )
  );
};
RichtextCarousel.propTypes = {
  data: PropTypes.shape({
    headingCopy: PropTypes.shape({
      raw: PropTypes.string.isRequired
    }).isRequired,
    contentful_id: PropTypes.string.isRequired,
    nodes: PropTypes.arrayOf(PropTypes.shape({
      copy: PropTypes.shape({
        raw: PropTypes.string.isRequired
      }).isRequired
    })).isRequired,
    autoPlay: PropTypes.bool.isRequired,
    mobileHeight: PropTypes.number.isRequired,
    tabletHeight: PropTypes.number.isRequired,
    desktopHeight: PropTypes.number.isRequired,
    backgroundColour: PropTypes.string,
    paddingAbove: PropTypes.string,
    paddingBelow: PropTypes.string,
    rowBackgroundColour: PropTypes.string.isRequired,
    carouselBackgroundColour: PropTypes.string.isRequired,
    nodeBackgroundColour: PropTypes.string.isRequired,
    nodeOutlineColour: PropTypes.string.isRequired
  }).isRequired
};

export default RichtextCarousel;
